import { MutationTree } from 'vuex'

// Окно быстрого просмотра одно на всю страницу: его рисует хост в лейауте,
// а карточки товаров только сообщают, какой товар открыть. Иначе в каталоге
// на 24 товара было бы 24 спрятанных окна.
interface IState {
  url: string | null
}

export const state = (): IState => ({
  url: null,
})

export const mutations: MutationTree<IState> = {
  open(state: IState, url: string) {
    state.url = url
  },
  close(state: IState) {
    state.url = null
  },
}
